import moment from "moment-timezone";

import { makePaginatedSearch } from "api/makeApiRequestType/makePaginatedSearch";
import { ValidationCallback } from "validation/validate";
import { formatDataForGetRequest } from "api/utils/formatDataForGetRequest";

export interface OutputRow {
	id: string;
	senderUid: string;
	recipientUid: string;
	message: string;
	dateSentUTC: Date;
	isRead: boolean;
}

interface RawApiOutputRow extends Omit<OutputRow, "dateSentUTC"> {
	dateSentUTC: string;
}

type Params = {
	uid1: string;
	uid2: string;
	cursor?: Date;
	cursorType?: "before" | "after";
};

const flagValidationErrorsInRow: ValidationCallback<RawApiOutputRow> = (
	input,
	{ flag, checkField }
) => {
	checkField("id", { type: "string" });
	checkField("senderUid", { type: "string" });
	checkField("recipientUid", { type: "string" });
	checkField("message", { type: "string" });
	checkField("dateSentUTC", { type: "datestring" });
	checkField("isRead", { type: "boolean" });
};

export const getRecentChatHistory = makePaginatedSearch<
	Params,
	RawApiOutputRow,
	OutputRow
>({
	endPoint: "recentChatHistory",
	flagValidationErrorsInRow,
	preProcessor: formatDataForGetRequest,
	postProcessor: (row, { uid1, uid2 }) => {
		if (typeof uid1 !== "string") {
			throw new Error("Uid1 was not a string");
		}

		if (typeof uid2 !== "string") {
			throw new Error("Uid2 was not a string");
		}

		return convertRowForApp(row, uid1, uid2);
	},
	sort: (a, b) => a.dateSentUTC.getTime() - b.dateSentUTC.getTime()
});

function convertRowForApp(
	{ id, dateSentUTC, senderUid, message, isRead }: RawApiOutputRow,
	uid1: string,
	uid2: string
) {
	return {
		id,
		dateSentUTC: moment.utc(dateSentUTC).toDate(),
		senderUid,
		message,
		isRead,
		recipientUid: uid1 === senderUid ? uid2 : uid1
	};
}
